export default class StorageService {
    /**
     * O guard do router (user/load_user) le varias chaves a cada navegacao:
     * um valor que nao e JSON (ex.: "undefined", gravado por
     * setItem(k, JSON.stringify(undefined))) derrubava a rota inteira e
     * deixava a tela em branco. Valor invalido vira null e sai do storage.
     */
    static get(key) {
        const raw = localStorage.getItem(key);
        if (!raw) return null;
        try {
            return JSON.parse(raw);
        } catch (e) {
            localStorage.removeItem(key);
            return null;
        }
    }

    static get_string(key) {
        return localStorage.getItem(key);
    }

    static token() {
        return localStorage.getItem("token");
    }

    static tpc() {
        return localStorage.getItem("tpc_id") ? JSON.parse(localStorage.getItem("tpc_id")) : null;
    }

    static set(key, object) {
        if (object != null) localStorage.setItem(key, JSON.stringify(object));
    }

    static add_to_array(key, object) {
        let arr = this.get(key);
        if (!(arr && arr instanceof Array)) {
            arr = [];
        }
        if (!arr.includes(object)) {
            arr.push(object);
        }
        localStorage.setItem(key, JSON.stringify(arr));
    }

    static remove_from_array(key, object) {
        let arr = this.get(key);
        if (!(arr && arr instanceof Array)) {
            arr = [];
        }
        if (arr.includes(object)) {
            arr.splice([arr.indexOf(2)], 1);
        }
        localStorage.setItem(key, JSON.stringify(arr));
    }
}
